import { Brand, Client, Folder } from 'src/typings';

export enum MarkUpType {
  FIXED = 'Фиксированная',
  PERCENT = 'Процент'
}

export interface Markup {
  id: number;
  rangeStart: number;
  rangeEnd: number | null;
  markup: number;
  priority: number;
  type: MarkUpType;
  folder?: Folder | null;
  brands?: Brand[];
  round: number;
  templateGenerated?: boolean;
  templateDelta?: number | null;
}

export interface ClientMarkup extends Markup {
  client?: Client;
}

export interface ResolveMarkupPriceDto {
  client_id?: number | null;
  product_id?: number | null;
  price: number;
}

export interface ResolveMarkupPriceResponse {
  price: number;
}

export interface ApplyClientMarkupTemplateDto {
  deltaPercent: number;
}

export interface CreateMarkupDto {
  priority?: number | null;
  type?: MarkUpType | null;
  folder?: Folder | null;
  rangeStart: number;
  rangeEnd?: number | null;
  markup: number;
  brands?: Brand[];
  round?: number;
}

export interface UpdateMarkupDto {
  id: number;
  priority?: number | null;
  type?: MarkUpType | null;
  folder?: Folder | null;
  rangeStart?: number | null;
  rangeEnd?: number | null;
  markup?: number | null;
  brands?: Brand[] | null;
  round?: number | null;
}

export interface SearchMarkupDto {
  id?: number;
  priority?: number;
  type?: MarkUpType;
  folder?: Folder;
  rangeStart?: number;
  rangeEnd?: number;
  markup?: number;
  brands?: Brand[];
  round?: number;
  order?: 'ASC' | 'DESC' | null;
  orderBy?: keyof Markup | null;
  limit?: number;
  offset?: number;
}
